import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  {
    path: '/',
    component: () => import('./page-steps/FindTripsForm.vue'),
    meta: {
      announcer: {
        message: 'Step 1 of 6 -  Find trips'
      }
    }
  },
  {
    path: '/trips',
    component: () => import('./page-steps/FindTripsList.vue'),
    meta: {
      announcer: {
        message: 'Step 2 of 6 -  Select a trip'
      }
    }
  },
  {
    path: '/trips/passengers',
    component: () => import('./page-steps/PassengerDetailsList'),
    meta: {
      announcer: {
        message: 'Step 3 of 5 -  Passenger details'
      }
    }
  },
  {
    path: '/trips/passengers/seats',
    component: () => import('./page-steps/PassengerSeatMapDeparture'),
    meta: {
      announcer: {
        message: 'Step 3b of 6 -  Seat selection departure'
      }
    }
  },
  {
    path: '/trips/passengers/seats/return',
    component: () => import('./page-steps/PassengerSeatMapReturn'),
    meta: {
      announcer: {
        message: 'Step 3c of 6 -  Seat selection return'
      }
    }
  },
  {
    path: '/cart',
    component: () => import('./page-steps/ShoppingCartPage'),
    meta: {
      announcer: {
        message: 'Step 4 of 6 -  Shopping Cart'
      }
    }
  },
  {
    path: '/cart/payment',
    component: () => import('./page-steps/PaymentInformationPage'),
    meta: {
      announcer: {
        message: 'Step 5 of 6 -  Payment Information Page'
      }
    }
  },
  {
    path: '/cart/payment/review',
    component: () => import('./page-steps/PaymentConfirmationPage'),
    meta: {
      announcer: {
        message: 'Step 6 of 6 -  Payment Confirmation Page'
      }
    }
  },
  {
    path: '/cart/payment/processed',
    component: () => import('./page-steps/PaymentProcessedPage'),
    meta: {
      announcer: {
        message: 'Transaction confirmation page'
      }
    }
  },
];

export default new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior() {
    return {
      selector: '#wb-cont',
      offset: { x: 0, y: 100 },
    };
  },
});
